import { FormControl, TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

export default function MultiplierInput({ setTypedMultiplier }) {
  const handleMultiplierInputChange = (event) => {
    setTypedMultiplier(event.target.value);
  };

  return (
    <FormControl>
      <TextField
        label="Multiplier"
        color="secondary"
        id="standard-basic"
        type="number"
        InputProps={{ inputProps: { step: 'any' } }}
        onChange={handleMultiplierInputChange}
      />
    </FormControl>
  );
}

MultiplierInput.propTypes = {
  setTypedMultiplier: PropTypes.func.isRequired,
};
